/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_ByosInputs */

const en_pricing_feature_byos = /** @type {(inputs: Pricing_Feature_ByosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring Your Own Stripe`)
};

const es_pricing_feature_byos = /** @type {(inputs: Pricing_Feature_ByosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trae tu propio Stripe (BYOS)`)
};

const fr_pricing_feature_byos = /** @type {(inputs: Pricing_Feature_ByosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apportez votre propre Stripe`)
};

const de_pricing_feature_byos = /** @type {(inputs: Pricing_Feature_ByosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring Your Own Stripe (BYOS)`)
};

const ja_pricing_feature_byos = /** @type {(inputs: Pricing_Feature_ByosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ご自身のStripeを利用 (BYOS)`)
};

const zh_pricing_feature_byos = /** @type {(inputs: Pricing_Feature_ByosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持自带 Stripe (BYOS)`)
};

const ar_pricing_feature_byos = /** @type {(inputs: Pricing_Feature_ByosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اربط حساب Stripe الخاص بك (BYOS)`)
};

const id_pricing_feature_byos = /** @type {(inputs: Pricing_Feature_ByosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bawa Stripe Sendiri (BYOS)`)
};

const it_pricing_feature_byos = /** @type {(inputs: Pricing_Feature_ByosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collega il tuo Stripe (BYOS)`)
};

const ru_pricing_feature_byos = /** @type {(inputs: Pricing_Feature_ByosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подключите свой Stripe (BYOS)`)
};

const pt_pricing_feature_byos = /** @type {(inputs: Pricing_Feature_ByosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traga seu próprio Stripe (BYOS)`)
};

const ko_pricing_feature_byos = /** @type {(inputs: Pricing_Feature_ByosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자체 Stripe 연결 (BYOS)`)
};

/**
* | output |
* | --- |
* | "Bring Your Own Stripe" |
*
* @param {Pricing_Feature_ByosInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_byos = /** @type {((inputs?: Pricing_Feature_ByosInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_ByosInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_feature_byos(inputs)
	if (locale === "es") return es_pricing_feature_byos(inputs)
	if (locale === "fr") return fr_pricing_feature_byos(inputs)
	if (locale === "de") return de_pricing_feature_byos(inputs)
	if (locale === "ja") return ja_pricing_feature_byos(inputs)
	if (locale === "zh") return zh_pricing_feature_byos(inputs)
	if (locale === "ar") return ar_pricing_feature_byos(inputs)
	if (locale === "id") return id_pricing_feature_byos(inputs)
	if (locale === "it") return it_pricing_feature_byos(inputs)
	if (locale === "ru") return ru_pricing_feature_byos(inputs)
	if (locale === "pt") return pt_pricing_feature_byos(inputs)
	return ko_pricing_feature_byos(inputs)
});